// Contexto que comparte el estado de las notificaciones a usuarios (Sistema B)
// entre todos los consumidores (la campanita del navbar, el modal post-login, etc.).
// Antes cada componente usaba useNotificacionesUsuario por separado, con estado
// local independiente: marcar una como leída en un componente no se reflejaba en
// los otros. Al centralizar el hook en un provider, todos ven el mismo estado.
import { createContext, useContext } from 'react';
import { useNotificacionesUsuario } from '../hooks/useNotificacionesUsuario';

export const NotificacionesContext = createContext(null);

export const useNotificaciones = () => {
    const context = useContext(NotificacionesContext);
    if (!context) {
        throw new Error('useNotificaciones debe usarse dentro de NotificacionesProvider');
    }
    return context;
};

export const NotificacionesProvider = ({ children }) => {
    const notificaciones = useNotificacionesUsuario();

    return (
        <NotificacionesContext.Provider value={notificaciones}>
            {children}
        </NotificacionesContext.Provider>
    );
};
